import { Box, Group, Stack, TextInput, useMantineTheme } from '@mantine/core';
import { Icon, PlainButton, Text, Title } from '@repo/foundations';
import { isEmpty } from 'lodash-es';
import { useContext, useState } from 'react';
import { useNavigate } from 'react-router';
import { AuthCard } from './AuthCard';
import { AuthButton } from './AuthLayouts/AuthButton';
import { AuthLayoutBase } from './AuthLayouts/AuthLayoutBase';
import { AuthStepStartContext } from './AuthStepStartContext';
import { AuthTermsAndPolicy } from './AuthTermsAndPolicy';

const REGEX_DOMAIN = /^[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/;

export function AuthStepSamlSso() {
	const theme = useMantineTheme();
	const navigate = useNavigate();
	const [value, setValue] = useState<string>('');
	const [error, setError] = useState<string | null>(null);

	const context = useContext(AuthStepStartContext);
	if (!context) {
		throw new Error(
			'AuthStepSamlSso must be used within a AuthStepStartContextProvider'
		);
	}
	const { startSamlAuth } = context;

	const handleClick = () => {
		// If it's an email address, extract the domain.
		let domain = value.includes('@') ? value.split('@')[1] : value;
		domain = domain.trim().toLowerCase();

		if (domain && !isEmpty(domain) && domain.match(REGEX_DOMAIN)) {
			startSamlAuth(domain);
		} else {
			setError('Please enter a valid domain');
		}
	};

	return (
		<AuthLayoutBase>
			<AuthCard>
				<Title order={1}>Continue with SAML SSO</Title>
				<Stack spacing="xl" mt="xl">
					<Stack spacing="md">
						<TextInput
							onKeyDown={(e) => {
								if (e.key === 'Enter') {
									handleClick();
								}
							}}
							onChange={(e) => setValue(e.currentTarget.value)}
							value={value}
							error={error}
							type="text"
							label="Work email or domain name"
							styles={{
								input: { borderRadius: theme.other.space[2], height: 44 },
							}}
						/>
						<AuthButton
							onClick={handleClick}
							disabled={!value}
							variant="primary"
						>
							<Group align="center" position="center">
								<Box>Sign in with SAML SSO</Box>
							</Group>
						</AuthButton>
					</Stack>
					<AuthTermsAndPolicy />
					<Group spacing="2xs" position="center">
						<Text size="sm" color="text/secondary/default">
							Back to
						</Text>
						<PlainButton
							onClick={() => {
								navigate('/auth');
							}}
						>
							<Group spacing="4xs">
								<Text size="sm" color="text/emphasis/default">
									log in
								</Text>
								<Icon name="arrowRight" color="icon/emphasis/default" />
							</Group>
						</PlainButton>
					</Group>
				</Stack>
			</AuthCard>
		</AuthLayoutBase>
	);
}
